function publish(type, value) {
    const event = new CustomEvent(type, value);
    window.dispatchEvent(event);
}

function onBodyReady(callback) {
    // `document.body` is present once parsing reaches <body>, well before
    // DOMContentLoaded. If it already exists we can fire the callback
    // synchronously. Otherwise we wait, but we also check `document.readyState`
    // to avoid the classic race where the listener is attached AFTER the
    // event already fired (e.g. tracking.js loaded async, body parsed during
    // the network wait, DOMContentLoaded dispatched before this callback was
    // even registered).
    if (document.body) {
        callback();
        return;
    }
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        // DOMContentLoaded has fired (interactive) or load has fired
        // (complete); body should exist. Defer to a microtask so callers
        // always observe async behavior consistently.
        Promise.resolve()
            .then(callback)
            .catch((err) => console.error('@vp/tracking: onBodyReady callback failed', err));
        return;
    }
    document.addEventListener('DOMContentLoaded', function () {
        callback();
    });
}

module.exports = {
    onBodyReady,
    publish
};
